module.exports = __webpack_public_path__ + "img/c3d94b6.png";